// document.addEventListener("DOMContentLoaded", function () {
//     const searchForm = document.getElementById("blog-search-form");
//     const searchInput = document.getElementById("blog-search-input");
//     const searchResults = document.getElementById("blog-search-results");

//     searchForm.addEventListener("submit", function (e) {
//         e.preventDefault();
//         const query = searchInput.value.trim();

//         if (query.length < 2) {
//             searchResults.innerHTML = "<p>Please enter at least 2 characters.</p>";
//             return;
//         }

//         fetch(`/search/suggest.json?q=${query}&resources[type]=article&resources[limit]=5`)
//             .then(response => response.json())
//             .then(data => {
//                 searchResults.innerHTML = ""; // Clear previous results

//                 if (data.resources.results.articles.length > 0) {
//                     data.resources.results.articles.forEach(article => {
//                         const articleHtml = `
//                             <div class="blog-search-item">
//                                 <a href="${article.url}">
//                                     <h3>${article.title}</h3>
//                                 </a>
//                                 <p>${article.excerpt || "No description available"}</p>
//                             </div>
//                         `;
//                         searchResults.innerHTML += articleHtml;
//                     });
//                 } else {
//                     searchResults.innerHTML = "<p>No blog posts found.</p>";
//                 }
//             })
//             .catch(error => {
//                 console.error("Error fetching search results:", error);
//                 searchResults.innerHTML = "<p>Something went wrong. Please try again.</p>";
//             });
//     });
// });





// document.addEventListener("DOMContentLoaded", function () {
//     const searchForm = document.getElementById("blog-search-form");
//     const searchInput = document.getElementById("blog-search-input");
//     const searchResults = document.getElementById("blog-search-results");
//     const customBlogsLoop = document.querySelector(".custom-blogs-loop");

//     searchForm.addEventListener("submit", function (e) {
//         e.preventDefault();
//         const query = searchInput.value.trim();

//         if (query) {

//             if (customBlogsLoop) {
//                 customBlogsLoop.style.display = "none";
//             }
          
//             // Perform AJAX search for blog articles only
//             fetch(`/search/suggest.json?q=${query}&resources[type]=article&resources[limit]=5`)
//                 .then(response => response.json())
//                 .then(data => {
//                     console.log(data);
//                     searchResults.innerHTML = ""; // Clear previous results

//                     // Check if 'resources' and 'results' are defined before accessing 'articles'
//                     if (data.resources && data.resources.results && data.resources.results.articles) {
//                         console.log("Articles found:", data.resources.results.articles);
//                         const articles = data.resources.results.articles;

//                         if (articles.length > 0) {
//                             articles.forEach(article => {
//                                 // Get featured image URL
//                                 const imageUrl = article.featured_image ? article.featured_image.url : '';

//                                 // Construct the article HTML
//                                 let articleHtml = `
//                                     <div class="post-wrapper blog-article-custom-card">
//                                         <div class="blog-post-image">
//                                             <div class="article__grid-image-wrapper">
//                                                 <div class="article__grid-image-container">
//                                                     <img class="article__grid-image lazyload" data-src="${imageUrl}" alt="${article.title}">
//                                                 </div>
//                                             </div>
//                                             <noscript>
//                                                 <div class="article__grid-image-wrapper">
//                                                     <img src="${imageUrl}" alt="${article.title}" class="article__grid-image">
//                                                 </div>
//                                             </noscript>
//                                             <div class="post-date">
//                                                 <span class="day">${new Date(article.published_at).getDate()}</span>
//                                                 <span class="month">${new Date(article.published_at).toLocaleString('default', { month: 'short' })}</span>
//                                             </div>
//                                         </div>
//                                         <div class="blog-post-content">
//                                             <div class="article-blog-content-inner">
//                                                 <div class="postTitle">
//                                                     <a href="${article.url}"> 
//                                                       <h2>${article.title}</h2> 
//                                                     </a>
//                                                 </div>
//                                                 <div class="postContent">
//                                                     <p>${article.excerpt || "No description available"}</p>
//                                                 </div>
//                                                 <div class="postDetails pl-0">
//                                                     <span class="blog_author">
//                                                       <i class="icon-calendar"></i>
//                                                       ${new Date(article.published_at).toLocaleDateString()}
//                                                     </span>
//                                                     <span class="blog_author">
//                                                       <i class="icon-user"></i>
//                                                       ${article.author || 'Unknown Author'}
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                             <div class="article-blog-readmore">
//                                               <div class="article-readmore">
//                                                 <a class="readmore" href="${article.url}">
//                                                   Read more
//                                                   <i class="icon-right-dir"></i>
//                                                 </a>
//                                               </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 `;

//                                 // Append the article HTML to the search results
//                                 searchResults.innerHTML += articleHtml;
//                             });
//                         } else {
//                             searchResults.innerHTML = "<p>No articles found.</p>";
//                         }
//                     }
//                 })
//                 .catch(error => {
//                     console.error("Error fetching articles:", error);
//                     searchResults.innerHTML = "<p>Error fetching results.</p>";
//                 });
//         }
//     });
// });




document.addEventListener("DOMContentLoaded", function () {
    const searchForm = document.getElementById("blog-search-form");
    const searchInput = document.getElementById("blog-search-input");
    const searchResults = document.getElementById("blog-search-results");
     const customBlogsLoop = document.querySelector(".custom-blogs-loop"); // Select the element to hide/show
    const searchLoader = document.getElementById("search-loader"); // Loader element

    searchForm.addEventListener("submit", function (e) {
        e.preventDefault();
        performSearch();
    });

    searchInput.addEventListener("input", function () {
        if (searchInput.value.trim() === "") {
            // Show the .custom-blogs-loop if the search input is empty
            if (customBlogsLoop) {
                customBlogsLoop.style.display = "block";
            }
            searchResults.innerHTML = ""; // Clear search results
        }
    });

    function performSearch() {
        const query = searchInput.value.trim();

        if (query) {
            // Hide the .custom-blogs-loop when a search is performed
            if (customBlogsLoop) {
                customBlogsLoop.style.display = "none";
            }

            // Show the loader
            if (searchLoader) {
                searchLoader.style.display = "block";
            }

            // Perform AJAX search for blog articles only
            fetch(`/search/suggest.json?q=${query}&resources[type]=article&resources[limit]=5`)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    searchResults.innerHTML = ""; // Clear previous results

                    if (searchLoader) {
                        searchLoader.style.display = "none";
                    }
                  
                    // Check if 'resources' and 'results' are defined before accessing 'articles'
                    if (data.resources && data.resources.results && data.resources.results.articles) {
                        console.log("Articles found:", data.resources.results.articles);
                        const articles = data.resources.results.articles;

                        if (articles.length > 0) {
                            articles.forEach(article => {
                                // Get featured image URL
                                const imageUrl = article.featured_image ? article.featured_image.url : '';

                                // Construct the article HTML
                                let articleHtml = `
                                    <div class="post-wrapper blog-article-custom-card">
                                        <div class="blog-post-image">
                                            <div class="article__grid-image-wrapper">
                                                <div class="article__grid-image-container">
                                                    <img class="article__grid-image lazyload" data-src="${imageUrl}" alt="${article.title}">
                                                </div>
                                            </div>
                                            <noscript>
                                                <div class="article__grid-image-wrapper">
                                                    <img src="${imageUrl}" alt="${article.title}" class="article__grid-image">
                                                </div>
                                            </noscript>
                                            <div class="post-date">
                                                <span class="day">${new Date(article.published_at).getDate()}</span>
                                                <span class="month">${new Date(article.published_at).toLocaleString('default', { month: 'short' })}</span>
                                            </div>
                                        </div>
                                        <div class="blog-post-content">
                                            <div class="article-blog-content-inner">
                                                <div class="postTitle">
                                                    <a href="${article.url}"> 
                                                      <h2>${article.title}</h2> 
                                                    </a>
                                                </div>
                                                <div class="postContent">
                                                    <p>${article.excerpt || "No description available"}</p>
                                                </div>
                                                <div class="postDetails pl-0">
                                                    <span class="blog_author">
                                                      <i class="icon-calendar"></i>
                                                      ${new Date(article.published_at).toLocaleDateString()}
                                                    </span>
                                                    <span class="blog_author">
                                                      <i class="icon-user"></i>
                                                      ${article.author || 'Unknown Author'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="article-blog-readmore">
                                              <div class="article-readmore">
                                                <a class="readmore" href="${article.url}">
                                                  Read more
                                                  <i class="icon-right-dir"></i>
                                                </a>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                `;

                                // Append the article HTML to the search results
                                searchResults.innerHTML += articleHtml;
                            });
                        } else {
                            searchResults.innerHTML = "<p>No articles found.</p>";
                        }
                    }
                })
                .catch(error => {
                    console.error("Error fetching articles:", error);
                    searchResults.innerHTML = "<p>Error fetching results.</p>";

                    // Hide the loader if an error occurs
                    if (searchLoader) {
                        searchLoader.style.display = "none";
                    }
                });
        }
    }
});





/////////////////////////


document.addEventListener("DOMContentLoaded", function() {
    // Select the h1 element inside .article-banner-heading
    const heading = document.querySelector('.article-banner-heading h1');

    // Check if the heading exists
    if (heading) {
        // Get the current text and capitalize it
        const originalText = heading.textContent;
        const capitalizedText = originalText
            .toLowerCase() // Convert the text to lowercase
            .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
        
        // Update the heading with the capitalized text
        heading.textContent = capitalizedText;
    }
});


document.querySelectorAll('.breadcrumbs__list li a').forEach(a => {
    a.textContent = a.textContent.toLowerCase();
});

document.querySelectorAll('.blog-post .blog-post-content h3').forEach(h3 => {
    h3.textContent = h3.textContent.toLowerCase();
});


// Swiper for Collection Slider
const swiper = new Swiper('.collection-slider', {
  loop: true,
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next-collection',
    prevEl: '.swiper-button-prev-collection',
  },
  speed: 600, // Adjust transition speed (600ms for smooth transition)
  effect: 'slide', // Default effect is 'slide', but you can use other effects like 'fade' or 'cube' if desired
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }
});

// Swiper for Recent Articles Slider
const swiper2 = new Swiper('.recent-articles-slider', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next-articles',
    prevEl: '.swiper-button-prev-articles',
  },
  speed: 600, // Adjust transition speed (600ms for smooth transition)
  effect: 'slide', // Default effect is 'slide', but you can try 'fade' or 'cube' for different transitions
});


